import styled from 'styled-components';
import { Link } from 'react-router-dom';

import ds from '../../utils/designSystem';

export const Container = styled.div`
  text-align: center;
  flex-grow: 2;
  height: 100%;
  width: 100%;
  background-color: ${ds.colors.black};
`;

export const IconImg = styled.img`
  width: fit-content;
  margin: 25px auto 0px;
`;

export const Title = styled.h1`
  color: ${ds.colors.white};
`;

export const PreTitle = styled.small`
  color: ${ds.colors.grayLight};
`;

export const SubTitle = styled.p`
  font-size: 12px;
  color: #7a7a7a;
`;

export const Wrapper = styled.div`
  width: 25%;
  height: ${props => (props.changePassword ? '65%' : '55%')};
  padding: 20px 3%;
  background-color: ${ds.colors.whiteSmoke};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0 auto;
  @media only screen and (max-width: ${ds.sizes.md}) {
    width: 70%;
  }
`;

export const Footer = styled.div`
  height: 80px;
  background-color: ${ds.colors.white};
  border-top: 8px solid ${ds.colors.grayLight};
  //helps to place the footer in the bottom
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const CustomLink = styled(Link)`
  color: ${ds.colors.blueDark};
  text-decoration: 'none';
`;
